import { useQuery } from "@tanstack/react-query";
import { getScores } from "../../services/score";

export const useGetScores = () => {
    return useQuery({
        queryKey: ["scores"],
        queryFn: getScores,
        staleTime: Infinity,
    });
}